<script lang="ts" setup>
import { onMounted, ref } from 'vue'

import { useRiskWarningPopUp } from '@/services/seoGlobalService'

const modalData = useRiskWarningPopUp()

const isVisible = ref<boolean>(false)

const setCookie = (name: string, value: string, days?: number) => {
  let cookieString = `${name}=${value}; path=/`
  if (days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    cookieString += `; expires=${expires}`
  }
  document.cookie = cookieString
}

const closeModal = () => {
  setCookie('indiaPopUp', 'true')
  document.body.style.overflow = ''

  isVisible.value = false
}

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null
  return null
}

onMounted(() => {
  const countryCookie = getCookie('country')
  const indiaPopUp = getCookie('indiaPopUp')
  isVisible.value = countryCookie === 'IN' && indiaPopUp !== 'true'

  if (isVisible.value) {
    document.body.style.overflow = 'hidden'
  }
})
</script>

<template>
  <div
    @click.prevent
    v-if="isVisible"
    class="fixed inset-0 z-[1000] w-full h-full bg-black bg-opacity-85"
  ></div>

  <div
    v-if="isVisible"
    class="fixed inset-0 top-[150px] px-[10px] pointer-events-none z-[3000] flex items-start justify-center w-full h-[85%] overflow-hidden"
  >
    <div
      class="bg-white lg:pb-20 rounded-[10px] shadow-lg w-full max-w-[1200px] lg:h-auto h-auto flex flex-col items-center pb-20 relative overflow-auto popup-vector pointer-events-auto"
    >
      <div
        v-html="modalData?.title"
        class="mb-10 lg:px-0 px-[10px] text-center lg:pt-20 h2-bold pt-[120px]"
      ></div>
      <div
        class="mb-20 lg:px-0 px-[10px] t butter-wysiwyg lg:max-w-[960px] w-full z-20 relative"
        v-html="modalData?.content"
      ></div>
      <div
        class="flex flex-col justify-center items-center w-full lg:gap-5 gap-[10px] lg:flex-row px-[6px] relative z-30"
      >
        <button
          class="px-[10px] py-2 text-white bg-red-150 rounded w-full max-w-[470px] button"
          @click="closeModal"
        >
          {{ modalData?.action_button_text }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 1024px) {
  .popup-vector::before {
    content: '';
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    background-size: auto;
    background-repeat: no-repeat;
    background-image: url('/assets/popup-vector.svg');
    background-position: -5px -344px;
    z-index: 10;
    opacity: 1;
  }
}
</style>
